import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";

import { MotesPaths, AccessRights } from "../models";
import { QueryFn } from "./database";
import { DatabaseService } from "./database.service";

@Injectable({ providedIn: 'root' })
export class AccessRightService {
    constructor(private db: DatabaseService) {
    }

    public watchAccessRights(projectKey: string): Observable<AccessRights> {
        let query: QueryFn = (query) => query.orderByChild('project').equalTo(projectKey);

        return this.db.list(MotesPaths.ACCESS_RIGHT_DB_PATH(), query).snapshotChanges().pipe(map((snapList) => {
            if(snapList.length > 0) return new AccessRights(snapList[0].payload.val(), snapList[0].key);
            return null;
        }));
    }

    public saveAccessRights(accessRights: AccessRights): Promise<any> {
        if(!accessRights || !accessRights.key) {
            console.error("Could not save empty access rights");
            return null;
        }
        // Save access rights to database
        return this.db.database.object(MotesPaths.ACCESS_RIGHT_DB_PATH(accessRights.key)).set(accessRights.toJson());
    }

    public createAccessRights(projectKey: string): AccessRights {
        return new AccessRights().init(projectKey);
    }

    private getAccessRightsByAppId(appId: string): Promise<AccessRights> | null {
        // For now just get project from static list (in order to not expose too much, make endpoint)
        let query: QueryFn = (query) => query.orderByChild('appIntegrationId').equalTo(appId);
        return this.db.list(MotesPaths.ACCESS_RIGHT_DB_PATH(), query).snapshotChanges().pipe(take(1), map((snapList) => {
            if(snapList.length > 0) return new AccessRights(snapList[0].payload.val(), snapList[0].key);
            return null;
        })).toPromise().catch(err => { console.log("Invalid app ID " + err); return null });
    }
}
